import React from 'react'
import PropTypes from 'prop-types'

import { get, isEmpty, size, truncate, uniqueId } from 'lodash'
import { Box, CircularProgress, TextField, Typography } from '@material-ui/core'

import scriptjs from 'scriptjs'
import CkEditorTextbox from '@scoir/components-core/dist/components/CkEditorTextbox'
import CharactersRemaining from '@scoir/components-core/dist/components/CharactersRemaining'
import { LinkField } from 'components/LinkField/MuiLinkField'

import { ErrorBoundary } from '@scoir/error-reporter'

import sanitize from 'common/sanitize-html-helper'
import './MessageContent.scss'

const MAX_LINKLABEL_LENGTH = 100

export default class MessageContent extends React.Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onToggleEnforceFocus: PropTypes.func.isRequired,
  }
  static defaultProps = {
    message: {},
  }
  constructor(props) {
    super(props)
    this.state = {
      loadedCkEditor: false,
      uId: uniqueId(),
    }
  }
  componentDidMount() {
    scriptjs(CkEditorTextbox.config.CDN, () => {
      this.setState({ loadedCkEditor: true })
    })
  }
  updateLinkLabel(value) {
    const { onChange } = this.props
    let nextValue = value
    if (size(value) > MAX_LINKLABEL_LENGTH) {
      nextValue = truncate(value, {
        length: MAX_LINKLABEL_LENGTH,
        omission: '',
      })
    }
    onChange('LinkLabel', nextValue)
  }
  render() {
    const { message, onChange, onToggleEnforceFocus } = this.props
    const { loadedCkEditor } = this.state
    return (
      <div className="outreach-message-form">
        <Box mb={1}>
          <TextField
            id={`outreach-message-subject-${this.uId}`}
            margin="normal"
            fullWidth
            variant="outlined"
            label="Subject"
            value={get(message, 'Subject', '')}
            onChange={(e) => onChange('Subject', e.target.value)}
          />
        </Box>
        <Box>
          <Typography paragraph>
            <strong>Body</strong>
          </Typography>
          {loadedCkEditor ? (
            <ErrorBoundary>
              <CkEditorTextbox
                onHideDialog={onToggleEnforceFocus}
                onShowDialog={onToggleEnforceFocus}
                initialContent={get(message, 'Message', '')}
                configuration="LINKS_AND_LISTS"
                ckEditor={window.CKEDITOR}
                additionalOptions={{ startupFocus: false, versionCheck: false }}
                onUpdate={(value) => onChange('Message', sanitize(value))}
              />
            </ErrorBoundary>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              my={3}
            >
              <CircularProgress
                role="status"
                aria-label="Loading"
                size={25}
              />
            </Box>
          )}
        </Box>
        <Box mt={3}>
          <Typography paragraph>
            <strong>Add Call to Action (Optional)</strong>
          </Typography>
          <LinkField
            label="Button Link URL"
            url={get(message, 'Link', '')}
            onChange={(url) => onChange('Link', url)}
          />
          {!isEmpty(get(message, 'Link')) && (
            <React.Fragment>
              <TextField
                id={`outreach-message-link-label-${this.uId}`}
                margin="normal"
                fullWidth
                variant="outlined"
                value={get(message, 'LinkLabel', '')}
                onChange={(e) => this.updateLinkLabel(e.target.value)}
                label="Button Link Label"
              />
              <CharactersRemaining
                textLength={size(get(message, 'LinkLabel', ''))}
                maxChars={MAX_LINKLABEL_LENGTH}
              />
            </React.Fragment>
          )}
        </Box>
      </div>
    )
  }
}
